import { Component, EventEmitter, Input, OnInit, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { GridConfig } from 'src/app/shared/grid-config';
import { AppGridComponent } from 'src/app/shared/grid/grid-component/grid-component';
import { ColDef } from 'ag-grid-community';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { GraphService } from 'src/app/services/graph/graph.service';
import { ConfirmationService } from 'src/app/services/confirmation.service';
import { ToastService } from 'src/app/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';
import { isNotEmptyArray } from 'src/app/utilities/utils';
import { AppConstants, ObservationEvents, StorageKeys } from 'src/app/utilities/constant';
import { UserAuthService } from 'src/app/services/user-auth/user-auth.service';


@Component({
  selector: 'app-roadmap-tab',
  templateUrl: './roadmap-tab.component.html',
  styleUrls: ['./roadmap-tab.component.scss'],
})
export class RoadmapTabComponent implements OnInit, OnChanges, OnDestroy {
  private isFetchingRoadmaps = false;
  private roadmapDebounceTimeout: any;
  private componentId: string;
  private static activeComponentId: string | null = null;
  private isNotificationTriggered = false;

  @Input() serviceMachineId: any;
  @Input() projectId: any;
  @Input() serviceId: any;
  @Input() machineId: any;
  @Input() machineDetails: any;
  @Input() stateAction: any;
  @Input() isCloneMode = false;
  @Output() roadmapViewActiveChange = new EventEmitter<boolean>();
  @ViewChild(AppGridComponent) gridComponent: AppGridComponent;
  public roadmapGridColumnDefs: ColDef[];
  public roadmapGridConfigItems: GridConfig;
  public isRoadmapGridDisplayed = true;
  public isRoadmapHistoryDisplayed = false;
  public isConfigureRoadmapDisplayed = false;
  public isNewRoadmapCreated: boolean = false;
  public isReadonlyRoadmap: boolean = false;
  public readOnlyRoadmapData: any;
  public roadmapCount: any = 0;
  public isCopiedRoadmap: boolean = false;
  public hideExit = false;
  public roadmapName = '';
  public isCustom: any;
  public roadmapData: any;
  public roadmapId='';
  public roadmapStatus='';
  public sectionList: any = {};
  public sectionDetails: any = {};
  public showHazardDetails : boolean;
  public historyData: any;
  private hasSoftDeletedRoadmaps = false;
  private userInfo: {
    name: string; userId: string; email: string; jobTitle: string; isGlobalAdmin: boolean; profileData: {}; permissions: any[]; // this.initailizeFroala();
  };

  constructor(
    public sharedValue: ShareValuesService,
    public translate: TranslateService, 
    public backendService: BackendCallService,
    public graphService: GraphService, 
    private confirmationService: ConfirmationService,
    private toastService: ToastService,
    private userAuthService: UserAuthService,
    private router: Router
  ) {}

  private notificationsSubscription: any;
  ngOnInit() {
    // Generate unique component ID for tracking
    this.componentId = `roadmap-tab-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    
    // Mark this component as the active one
    RoadmapTabComponent.activeComponentId = this.componentId;
    
    this.userInfo = this.userAuthService.getUserList();
    this.sharedValue.selectedRoadmapsList = [];
    this.machineId = this.machineDetails?.machine_Id;
    this.serviceMachineId = this.machineDetails?.serviceMachine_Id?.serviceMachineId;
    this.fnInitialiseRoadmapGrid();
    if (this.isCloneMode) {
      this.roadmapCount = 0;
      this.sharedValue.selectedRoadmapsList = [];
      this.sharedValue.isGridDataLoading = false;
      setTimeout(() => {
        this.gridComponent?.fnAppendAllDataInGrid(this.sharedValue.selectedRoadmapsList);
      }, 150);
    } else {
      this.getConfiguredroadmaps();
    }
    if (this.stateAction) {
      this.processNavigationState(this.stateAction);
    }
    // Subscribe to notifications$ for real-time updates
    this.setupNotificationSubscription();
  }

  private setupNotificationSubscription() {
    // Clean up any existing subscription first
    if (this.notificationsSubscription) {
      this.notificationsSubscription.unsubscribe();
    }
    
    this.notificationsSubscription = this.sharedValue.notifications$.subscribe((notifications) => {
      // Check if the notification is related to roadmap import/configuration
      const hasRoadmapNotification = (notifications || []).some((notification: any) => {
        const message = notification?.notification?.toLowerCase() || '';
        return message.includes('roadmap') || message.includes('configured') || message.includes('configure');
      });
      
      if (hasRoadmapNotification) {
        const isActiveComponent = RoadmapTabComponent.activeComponentId === this.componentId;
        
        // Only process if this is the currently active component
        if (!isActiveComponent) {
          return;
        }
        
        // Only refresh if this component is currently displayed and active
        if (this.serviceMachineId && this.isRoadmapGridDisplayed && !this.isRoadmapHistoryDisplayed) {
          this.isNotificationTriggered = true;
          this.refreshConfiguredRoadmapsDebounced();
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    // If serviceMachineId changes, make this component active again
    if (changes['serviceMachineId'] && !changes['serviceMachineId'].firstChange) {
      RoadmapTabComponent.activeComponentId = this.componentId;
    }
    
    if (changes['stateAction'] && !changes['stateAction'].firstChange && changes['stateAction'].currentValue) {
      this.processNavigationState(changes['stateAction'].currentValue);
    }
  }

  ngOnDestroy() {
    this.roadmapViewActiveChange.emit(false);
    // Clear active component ID if this was the active one
    if (RoadmapTabComponent.activeComponentId === this.componentId) {
      RoadmapTabComponent.activeComponentId = null;
    }
    
    if (this.notificationsSubscription) {
      this.notificationsSubscription.unsubscribe();
      this.notificationsSubscription = null;
    }
    
    // Clear any pending debounce timeout
    if (this.roadmapDebounceTimeout) {
      clearTimeout(this.roadmapDebounceTimeout);
      this.roadmapDebounceTimeout = null;
    }
  }



  /**
   * To get configured roadmaps
   */
  getConfiguredroadmaps() {
    if (this.isFetchingRoadmaps) return;
    this.isFetchingRoadmaps = true;
    this.backendService.getConfiguredroadmaps(this.serviceMachineId, this.projectId)
      .subscribe((data: any) => {
        if (data.length) {
          this.sharedValue.selectedRoadmapsList = [];
          this.sharedValue.selectedRoadmapsList = data;
          this.sharedValue.selectedRoadmapsList = this.sharedValue.selectedRoadmapsList.map(item => this.mapRoadmapGridItem(item));
          this.hasSoftDeletedRoadmaps = this.sharedValue.selectedRoadmapsList.some(item => item.isSoftDeleted);
          this.fnCreateRoadmapColumnDefs();
          this.gridComponent?.updateGridColumnDefinitions(this.roadmapGridColumnDefs);

          setTimeout(() => {
            this.gridComponent?.refreshGridData();
          }, 1000);
        } else {
          this.sharedValue.selectedRoadmapsList = [];
          this.hasSoftDeletedRoadmaps = false;
          this.fnCreateRoadmapColumnDefs();
          this.gridComponent?.updateGridColumnDefinitions(this.roadmapGridColumnDefs);
          this.sharedValue.isGridDataLoading = false;
          this.gridComponent.fnAppendAllDataInGrid(this.sharedValue.selectedRoadmapsList);
        }
        this.roadmapCount = this.sharedValue.selectedRoadmapsList.filter(item => !item.isSoftDeleted).length;
        const customRoadmapsList = (this.sharedValue.customRaodmapsList || []).map(item => this.mapRoadmapGridItem(item));
        this.sharedValue.selectedRoadmapsList.push(...customRoadmapsList);
        this.checkRoadMapStatus();
        setTimeout(() => {
          this.fnGetRoadmapGridConfigItems();
        }, 1100);
        this.isFetchingRoadmaps = false;
      },
      (err) => {
        this.sharedValue.isGridDataLoading = false;
        this.isFetchingRoadmaps = false;
      }
    );
  }

  private mapRoadmapGridItem(item) {
    const currentStatus = item.roadmapStatus;
    const isSoftDeleted = this.isRoadmapSoftDeleted(item);
    const isLockedByOtherUser = item.isLocked && item.lockedByUserId !== this.userInfo?.userId;

    return {
      ...item,
      isSoftDeleted,
      isNotSoftDeleted: !isSoftDeleted,
      isDeletedOrLockedByOtherUser: isSoftDeleted || isLockedByOtherUser,
      hideDeleteAction: isSoftDeleted,
      hideRestoreAction: !isSoftDeleted,
      disableLockAction: isSoftDeleted,
      hideLockedAction: !item.isLocked,
      hideUnlockedAction: item.isLocked,
      customeRowClass: isSoftDeleted,
      status: currentStatus,
      backgroundColor: isSoftDeleted ? '#cccccc' : this.getRoadmapStatusColor(currentStatus),
      isUnlocked: !item.isLocked,
      isLockedByOtherUser,
      lockedByUserName: item.lockedByUserName,
      isGlobalAdmin: item.isGlobalAdmin
    };
  }

  private isRoadmapSoftDeleted(item): boolean {
    const softDeletedValue = item?.issoftdeleted ?? item?.isSoftDeleted ?? item?.is_soft_deleted ?? item?.IsSoftDeleted;
    return softDeletedValue === true || softDeletedValue === 'true';
  }

  private getRoadmapStatusColor(currentStatus: string): string {
    switch (currentStatus) {
      case 'In Progress':
        return '#f2db7c';
      case 'Completed':
        return '#71eb8d';
      case 'Not Started':
        return '#cccccc';
      default:
        return '#97B5FA';
    }
  }

  /**
   * To check the status of the roadmaps and update the selectedRoadmapsList accordingly
   */
  checkRoadMapStatus() {
    const listsOfRoadMapStatus = this.sharedValue.getRoadMapStatusLists();
    if (isNotEmptyArray(listsOfRoadMapStatus) && isNotEmptyArray(this.sharedValue.selectedRoadmapsList)) {
      listsOfRoadMapStatus.forEach(_ls => {
        this.sharedValue.selectedRoadmapsList.forEach(_sl => {
          if (_sl.id == _ls.roadMapId) {_sl.status = _ls.status ? _ls.status : 'Not Started';}
        });
      });
    }
  }

  /**
   * To configure roadmaps
   */
  public configureRoadmaps() {
    if (this.isCloneMode) {
      return;
    }
    const navigationExtras: NavigationExtras = {
      queryParams: {
        serviceMachineId: this.serviceMachineId,
        project_id: this.projectId,
        machineId: this.machineId,
        machineDetails: JSON.stringify(this.machineDetails),
        activeTab: 'ROADMAPS'
      },
      queryParamsHandling: 'merge'
    };
    this.router.navigate(['/clone-roadmap'], navigationExtras);
  }

  /**
   * Initializes the roadmap grid with column definitions and configuration items.
   */
  private fnInitialiseRoadmapGrid() {
    this.fnCreateRoadmapColumnDefs();
    this.fnGetRoadmapGridConfigItems();
    setTimeout(() => {
      this.gridComponent?.initializeGrid(false);
    }, 100);
  }

  /**
   * Creates the column definitions for the roadmap grid.
   */
  private fnCreateRoadmapColumnDefs() {
    const updatedByMinWidth = this.hasSoftDeletedRoadmaps ? 150 : 150;
    const updatedDateMinWidth = this.hasSoftDeletedRoadmaps ? 150 : 250;
    const strictUpdatedByWidth = this.hasSoftDeletedRoadmaps
      ? { width: 150, maxWidth: 150, flex: 0 }
      : {};
    const strictUpdatedDateWidth = this.hasSoftDeletedRoadmaps
      ? { width: 150, maxWidth: 150, flex: 0 }
      : {};
    const expiryDateColumnWidth = this.hasSoftDeletedRoadmaps
      ? { minWidth: 120, width: 120, maxWidth: 120, flex: 0 }
      : { minWidth: 150 };
    const columnDefs: ColDef[] = [
      {
        headerName: this.translate.instant('Roadmap'),
        field: 'roadmapName',
        minWidth: 150,
        sortable: true,
        suppressMenu: true,
        cellClass:'grid-column-value grid-text-color'
      },
      {
        headerName : this.translate.instant('Updated By'),
        field: 'updatedBy',
        minWidth : updatedByMinWidth,
        ...strictUpdatedByWidth,
        sortable: true,
        suppressMenu: true,
        cellClass:'grid-column-value'
      },
      {
        headerName : this.translate.instant('Updated Date'),
        field: 'updatedAt',
        minWidth: updatedDateMinWidth,
        ...strictUpdatedDateWidth,
        sortable: true,
        suppressMenu: true,
        cellClass:'grid-column-value'
      }
    ];

    if (this.hasSoftDeletedRoadmaps) {
      columnDefs.push({
        headerName : this.translate.instant('Expiry Date'),
        field: 'expiryDateDisplay',
        ...expiryDateColumnWidth,
        sortable: true,
        suppressMenu: true,
        cellClass: params => params.data?.isSoftDeleted ? 'grid-column-value roadmap-expiry-date' : 'grid-column-value'
      });
    }

    columnDefs.push(
      {
        headerName : this.translate.instant('Roadmap Status'),
        field: 'roadmapStatus',
        minWidth: 150,
        sortable: true,
        suppressMenu: true,
        cellClass:'grid-column-value',
        cellRenderer : 'buttonRenderer'
      },
      {
        headerName: this.translate.instant('History'),
        cellRenderer: 'actionRenderer',
        field: 'userActionField',
        suppressMovable: true,
        suppressMenu: true,
        sortable: false,
        minWidth: 120,
        maxWidth: 120,
        cellClass: 'float-right icon-action-cell',
        headerComponentParams:
          [
            {
              buttonClass: 'more-icon',
              buttonTooltip: this.translate.instant('History'),
              userAction: this.translate.instant('History'),
              url: 'assets/icon/History_icon.svg',
              disableProperty: 'isDeletedOrLockedByOtherUser'
            }
          ]
      },
      {
        headerName: this.translate.instant('Actions'),
        cellRenderer: 'actionRenderer',
        field: 'userActionField',
        suppressMovable: true,
        suppressMenu: true,
        sortable: false,
        minWidth: 120,
        maxWidth: 250,
        cellClass: 'float-right icon-action-cell',
        headerComponentParams:
          [
            {
              buttonClass: 'more-icon',
              buttonTooltip: this.translate.instant('Edit'),
              userAction: this.translate.instant('Edit'),
              url: 'assets/images/edit.svg',
              disableProperty: 'isDeletedOrLockedByOtherUser'
            },
            {
              buttonClass: 'more-icon',
              buttonTooltip: this.translate.instant('Delete'),
              userAction: this.translate.instant('Delete'),
              url: 'assets/images/Delete.svg',
              greyOutProperty: 'isLocked',
              hideProperty: 'hideDeleteAction'
            },
            {
              buttonClass: 'more-icon',
              buttonTooltip: this.translate.instant('Restore'),
              userAction: this.translate.instant('Restore'),
              url: 'assets/images/Restore.svg',
              hideProperty: 'hideRestoreAction'
            },
            {
              buttonClass: 'more-icon',
              buttonTooltip: this.translate.instant('Locked'),
              userAction: this.translate.instant('Locked'),
              url: 'assets/images/locked.svg',
              disableProperty: 'disableLockAction',
              hideProperty: 'hideLockedAction'
            },
            {
              buttonClass: 'more-icon',
              buttonTooltip: this.translate.instant('Unlocked'),
              userAction: this.translate.instant('Unlocked'),
              url: 'assets/images/unlocked.svg',
              disableProperty: 'disableLockAction',
              hideProperty: 'hideUnlockedAction'
            }
          ]
      }
    );

    this.roadmapGridColumnDefs = columnDefs;
  }

  /**
   * To get the configuration items for the roadmap grid.
   */
  private fnGetRoadmapGridConfigItems() {
    this.roadmapGridConfigItems = new GridConfig(
      'id',
      'id',
      false,
      true,
      true,
      false,
      'desc',
      40,
      'no_data_available',
      this.translate.instant('Total') + ': ' + this.roadmapCount+ ' ' + this.translate.instant('Roadmaps'),
      '',
      this.translate.instant('Configure Roadmaps'),
      true,
      1,
      'grid-wrapper-height-40',
      '',
      '',
      '',
      '',
      this.isCloneMode
    );
  }

  /**
   * Action on grid cell click.
   * @param params 
   */
  public fnOnGridCellClick(params) {
    const isActionColumn = params?.colDef?.cellRenderer === 'actionRenderer';
    const clickEvent = params?.event as MouseEvent | KeyboardEvent | undefined;
    const eventTarget = clickEvent?.target as HTMLElement | null;
    const isIconInteraction = !!eventTarget?.closest('a[role="button"], ion-icon');
    const isUserMouseClick = clickEvent?.type === 'click' && (clickEvent as MouseEvent)?.isTrusted;

    // Ignore click on action-cell empty area/focus rectangle; only icon clicks should trigger.
    if (isActionColumn && isUserMouseClick && !isIconInteraction) {
      params.data.userAction = null;
      params.node?.setData?.(params.data);
      return;
    }

    // Prevent Edit and Delete actions if locked by another user
    const isDeletedOrLockedByOtherUser = params.data.isDeletedOrLockedByOtherUser;
    
    if(params.data.userAction == this.translate.instant('Edit')) {
      if (isDeletedOrLockedByOtherUser) return;
      this.fnViewRoadmap(params.data); this.hideExit = true;
    }
    else if(params.data.userAction == this.translate.instant('Delete')) {
      if (params.data.isLocked) {
        this.showLockedRoadmapValidation(params.data);
        return;
      }
      this.deleteRoadmapConfirmation(params.data);
    }
    else if(params.data.userAction == this.translate.instant('Restore')) {
      this.restoreRoadmap(params.data);
    }
    else if(params.data.userAction == this.translate.instant('History')) {
      if (isDeletedOrLockedByOtherUser) return;
      this.fnViewHistory(params.data); this.hideExit = true;
    }
    else if(params.data.userAction == this.translate.instant('Locked'))
      {this.handleLockedButtonClick(params.data);}

    // Clear action after handling to prevent stale action reuse on later cell clicks.
    if (isActionColumn) {
      params.data.userAction = null;
      params.node?.setData?.(params.data);
    }
  }

  /**
   * Shows validation popup for locked roadmap when trying to delete.
   * @param roadmap 
   */
  private async showLockedRoadmapValidation(roadmap) {
    const lockedByUserName = roadmap.lockedByUserName || this.translate.instant('another user');
    const validationMessage = this.translate.instant('unlock_before_delete_validation', { userName: lockedByUserName });
    
    await this.confirmationService.presentConfirmationModal(
      validationMessage,
      this.translate.instant('OK'),
      false
    );
  }

  /**
   * Handles the Locked button click. Only Global Admin can unlock on web.
    * Case 1: Non-admin + locked by same user → show mobile-app unlock warning
    * Case 2: Non-admin + locked by different user → show locked information popup
    * Case 3: Global admin + locked by same user → unlock without validation
    * Case 4: Global admin + locked by different user → unlock with validation popup
   * @param roadmap 
   */
  private async handleLockedButtonClick(roadmap) {
    // Only process if roadmap is locked
    if (!roadmap.isLocked) {
      return;
    }

    // Convert both to strings for reliable comparison
    const lockedByUserId = String(roadmap.lockedByUserId || '');
    const currentUserId = String(this.userInfo?.userId || '');
    const isLockedBySameUser = lockedByUserId === currentUserId && lockedByUserId !== '';
    const isGlobalAdmin = this.userInfo?.isGlobalAdmin;
    const lockedByUserName = roadmap.lockedByUserName || this.translate.instant('another user');

    if (!isGlobalAdmin) {
      if (isLockedBySameUser) {
        this.toastService.presentToast(
          this.translate.instant('Please login to mobile app for unlocking roadmap'),
          4000,
          AppConstants.WARNING_SNACKBAR,
          'top'
        );
        return;
      }

      await this.confirmationService.presentConfirmationModal(
        `${this.translate.instant('Locked')}!`,
        this.translate.instant('OK'),
        true,
        this.translate.instant('Cancel'),
        this.translate.instant('The roadmap is currently locked and is under use by {{userName}}.', { userName: lockedByUserName })
      );
      return;
    }

    // Global admin + locked by same user → unlock without validation
    if (isLockedBySameUser) {
      await this.unlockRoadmap(roadmap);
      return;
    }

    // Global admin + locked by different user → unlock with validation popup
    const confirmationTitle = this.translate.instant('unlock_roadmap_confirmation', { userName: lockedByUserName });
    const confirmationSubtitle = this.translate.instant('unlock_roadmap_warning');
    
    const isConfirmed = await this.confirmationService.presentConfirmationModal(
      confirmationTitle,
      this.translate.instant('Unlock'),
      true,
      this.translate.instant('Cancel'),
      confirmationSubtitle
    );
    if (isConfirmed) {
      await this.unlockRoadmap(roadmap);
    }
  }

  /**
   * Unlocks a roadmap.
   * @param roadmap 
   */
  private unlockRoadmap(roadmap): Promise<void> {
    return new Promise((resolve, reject) => {
      const payload = {
        roadmapId: roadmap.id,
        userId: this.userInfo?.userId
      };
      this.backendService.unlockRoadmap(payload).subscribe(
        (res: any) => {
          this.toastService.presentToast(this.translate.instant('roadmap_unlocked_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
          this.getConfiguredroadmaps();
          resolve();
        },
        (err) => {
          this.toastService.presentToast(this.translate.instant('failed_to_unlock_roadmap'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
          reject(err);
        }
      );
    });
  }

  /**
   * To view the roadmap details.
   * @param roadmap 
   */
  private fnViewRoadmap(roadmap) {
    document.body.classList.remove('hazard-overlay-active');
    this.isReadonlyRoadmap = false;
    this.handleViewRoadmap(roadmap, false);
  }

  /**
   * To handle  viewing of the roadmap, either in readonly mode or editable mode.
   * @param roadmap 
   * @param isReadonly 
   */
  private handleViewRoadmap(roadmap, isReadonly: boolean = false) {
    this.isRoadmapHistoryDisplayed = false;
    this.roadmapName = isReadonly ? roadmap.roadmap_name : roadmap.roadmapName;
    this.roadmapId = isReadonly ? roadmap.roadmap_id : roadmap.id;
    this.roadmapStatus = isReadonly ? roadmap.roadmap_status : roadmap.roadmapStatus;
    this.isCustom = roadmap?.isCustom;
    this.sectionList = [];
    this.sectionDetails = [];
    const roadmapId = isReadonly ? roadmap.roadmap_id : roadmap.id;
    this.backendService.roadmapExecution(roadmapId, null, false).subscribe((data: any) => {
      if (data) {
        this.isCopiedRoadmap = data.response.is_roadmap_copied;
        this.sectionList = data.response.sectionList;
        this.sectionDetails = data.response.sectionDetails;
      }
    }, err => { });
    this.isRoadmapGridDisplayed = false;
    this.roadmapViewActiveChange.emit(true);
  }

  /**
   * To view the history of the roadmap.
   * @param roadmap 
   */
  private fnViewHistory(roadmap) {
    const roadmapId = roadmap.id;
    this.backendService.getRoadmapHistory(roadmapId, this.serviceMachineId).subscribe((data: any) => {
      if(data.statusCode == 200)
      {
        if (data && data?.response) {
          this.isRoadmapHistoryDisplayed = true;
          this.isRoadmapGridDisplayed = false;
          this.historyData = data.response;
        }
      }
      else if(data.statusCode == 404)
      {
        this.isRoadmapHistoryDisplayed = false;
        this.isRoadmapGridDisplayed = true;
        if (data.message == "Data not found") {
          this.toastService.presentToast(this.translate.instant('no_roadmap_history'), 3000, AppConstants.ERROR_SNACKBAR, 'top');
        }
      }
    }, err => {
      this.toastService.presentToast(this.translate.instant('no_roadmap_history'), 3000, AppConstants.ERROR_SNACKBAR, 'top');
    })
  }

  /**
   * To confirm deletion of a roadmap.
   * @param roadmap 
   */
  public async deleteRoadmapConfirmation(roadmap) {
    const itemName = this.translate.instant('roadmap');
    const title = this.translate.instant('Are_you_sure_you_want_to_delete') + ' ' + itemName + '?';
    const actionText = this.translate.instant('Delete');
    const subtitleName = roadmap?.roadmapName;
    const subtitle = subtitleName ? `'${subtitleName}'` : null;
    const noticeTitle = this.translate.instant('soft_delete_roadmap_notice_title');
    const noticeMessage = this.translate.instant('soft_delete_roadmap_notice_message');

    const isConfirmed = await this.confirmationService.presentConfirmationModal(
      title,
      actionText,
      true,
      this.translate.instant('Cancel'),
      subtitle,
      {
        noticeTitle,
        noticeMessage,
        modalCssClass: 'roadmap-delete-confirmation-modal'
      }
    );
    if (isConfirmed) {    
      this.deleteRoadmap(roadmap); 
    }
  }

  /**
   * To delete a roadmap.
   * @param roadmap 
   */
  deleteRoadmap(roadmap) {
    const payload = {
      serviceMachineId: this.serviceMachineId,
      roadmapId: roadmap.id,
      isCustom: roadmap.isCustom,
      projectId: this.projectId
    };
    if (!roadmap.isCustom) {
      this.backendService.deleteRoadmap(payload).subscribe((res: any) => {
        this.getConfiguredroadmaps();        
        this.toastService.presentToast(this.translate.instant('roadmap_deleted_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
      }, err => {        
        this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
      });
    } if (roadmap.isCustom && roadmap.id !== '') {
      this.backendService.deleteRoadmap(payload).subscribe((res: any) => {
        this.getConfiguredroadmaps();       
        this.toastService.presentToast(this.translate.instant('roadmap_deleted_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
      }, err => {       
        this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
      });
    }
  }

  restoreRoadmap(roadmap) {
    const roadmapId = roadmap?.id || roadmap?.roadmapId || roadmap?.roadmap_id;
    if (!roadmapId) {
      this.toastService.presentToast(this.translate.instant('roadmap_restore_failed'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
      return;
    }

    const payload = {
      roadmapId,
      userId: this.userInfo?.userId
    };

    this.backendService.restoreRoadmap(payload).subscribe((res: any) => {
      if (!res?.statusCode || res.statusCode === 200) {
        this.getConfiguredroadmaps();
        this.toastService.presentToast(this.translate.instant('roadmap_restored_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
        return;
      }

      this.toastService.presentToast(res?.message || this.translate.instant('roadmap_restore_failed'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
    }, err => {
      this.toastService.presentToast(err?.error?.message || this.translate.instant('roadmap_restore_failed'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
    });
  }

  /**
   * To configure a new roadmap.
   */
  private configureNewRoadmap() {
    this.isRoadmapGridDisplayed = false;
    this.isRoadmapHistoryDisplayed = false;
    this.roadmapName = '';
    this.roadmapId = '';
    this.isCustom = true;
    this.sectionList = [];
    this.sectionDetails = [];
    this.readOnlyRoadmapData = null;
    this.roadmapViewActiveChange.emit(true);
  }

  /**
   * Processes the navigation state to handle different actions like creating a new roadmap, going back, importing a roadmap, or exiting the roadmap.
   */
  public processNavigationState(action) {
    document.body.classList.remove('hazard-overlay-active');
    const state = history.state as { action?: string, data?: any, timestamp?: number };
    if (action) {
      switch (action) {
        case ObservationEvents.NEW_ROADMAP:
          this.isNewRoadmapCreated = true;
          this.isReadonlyRoadmap = false;
          this.isCopiedRoadmap = false;
          this.configureNewRoadmap();
          break;
        case ObservationEvents.GO_BACK:
          this.isReadonlyRoadmap = false;
          this.isNewRoadmapCreated = false;
          this.readOnlyRoadmapData = null;
          sessionStorage.removeItem(StorageKeys.READONLY_ROADMAP_DATA);
          this.getConfiguredroadmaps();
          break;
        case ObservationEvents.IMPORT_ROADMAP:
          this.isReadonlyRoadmap = false;
          const {
            isConfigureRoadmap,
            selectedOption,
            selectedPredefinedRoadmapLists,
            modeIds,
            machineId,
            isConfirmCopyHazardLocation,
            sConfirmCopyHazardLocation
          } = state.data;
          const shouldCopyHazardLocation = typeof isConfirmCopyHazardLocation === 'boolean'
            ? isConfirmCopyHazardLocation
            : sConfirmCopyHazardLocation;
          if (isConfigureRoadmap) {
            if (Array.isArray(selectedPredefinedRoadmapLists) && selectedPredefinedRoadmapLists.length > 0) {
              this.storeSelectedPredefinedRoadmap(selectedPredefinedRoadmapLists, selectedOption, modeIds, machineId, shouldCopyHazardLocation);
            }
          }
          break;
        case ObservationEvents.EXIT_ROADMAP:
          this.isReadonlyRoadmap = false;
          this.isNewRoadmapCreated = false;
          this.readOnlyRoadmapData = null;
          sessionStorage.removeItem(StorageKeys.READONLY_ROADMAP_DATA);
        default:
          break;
      }
    }
  }

  /**
   * To store the selected predefined roadmap.
   * @param predefinedRoadmapLists 
   * @param selectedOption 
   */
  storeSelectedPredefinedRoadmap(predefinedRoadmapLists, selectedOption?, modeIds?, machineId?, isConfirmCopyHazardLocation?) {
    if (isNotEmptyArray(predefinedRoadmapLists)) {
      const selectedRoadmapsList = [];
      predefinedRoadmapLists?.forEach(eachRoadmap => {
        selectedRoadmapsList.push(eachRoadmap.roadmap_id);
        selectedRoadmapsList?.map(item => {
          if (item?.roadmapStatus == null || item?.roadmapStatus == undefined) {
            const currentStatus = item?.roadmapStatus?.toLowerCase();
            switch (currentStatus) {
              case 'in-progress':
              case 'in progress':
                return { ...item, status: currentStatus, backgroundColor: '#37D9BF' };
              case 'on hold':
                return { ...item, status: currentStatus, backgroundColor: '#F9DA7C' };
              case 'blocked':
                return { ...item, status: currentStatus, backgroundColor: '#f78686' };
              default:
                return { ...item, status: currentStatus, backgroundColor: '#97B5FA' };
            }
          }
        });
      });
      const payload = {
        serviceMachineId: this.serviceMachineId,
        projectId: this.projectId,
        isTemplate: true,
        roadmapIds: selectedRoadmapsList,
        userEmail: this.userInfo.email,
        userId: this.userInfo.userId,
        modeIds: modeIds,
        machineId: machineId
      };
      if (typeof isConfirmCopyHazardLocation === 'boolean') {
        payload['isConfirmCopyHazardLocation'] = isConfirmCopyHazardLocation;
      }
      if (selectedOption == 'template') {
        payload['isFromSimilarMachine'] = false;
        payload.isTemplate = true;
      }else {
        payload['isFromSimilarMachine'] = true;
        payload.isTemplate = false;
      }
      this.backendService
        .configureRoadmap(payload)
        .subscribe(
          (data: any) => {
            if (data.statusCode === 200) {
              this.toastService.presentToast('Configure roadmap request queued', 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
            }    
          },
          (err) => {
            console.log('getting issue in storing selected predefined roadmap :', err);
          }
        );
    }
  }

  /**
   * To handle the exit event from the roadmap view.
   */
  fnExitEvent($event)
  {
    this.isRoadmapGridDisplayed = true;
    this.hideExit = false;
    this.isNewRoadmapCreated = false;
    this.roadmapViewActiveChange.emit(false);
    this.getConfiguredroadmaps();
  }

    private refreshConfiguredRoadmapsDebounced() {
    if (this.roadmapDebounceTimeout) {
      clearTimeout(this.roadmapDebounceTimeout);
    }
    // Set a new timeout with increased delay to prevent multiple rapid calls
    this.roadmapDebounceTimeout = setTimeout(() => {
      this.refreshFromNotification();
    }, 500);
  }

  private refreshFromNotification() {
    // Verify this was actually triggered by a notification
    if (!this.isNotificationTriggered) {
      return;
    }
    
    // Reset the flag
    this.isNotificationTriggered = false;
    
    // Triple-check if component is still active and relevant
    if (this.serviceMachineId && 
        !this.isFetchingRoadmaps && 
        this.isRoadmapGridDisplayed && 
        !this.isRoadmapHistoryDisplayed &&
        RoadmapTabComponent.activeComponentId === this.componentId) {
      this.getConfiguredroadmaps();
    }
  }
}